<template>
	<page>
		<module>
			<div class="order-state flex-between-center"  v-if="orderDetail">
				<h1>状态：{{orderState}}</h1>
				<p>{{orderStateWord}}</p>
			</div>

			<div class="order-node">
				<node-list :nodes="nodeList"></node-list>
			</div>
			
			<div class="order-detail">
				<dt>订单明细</dt>
				<c-table v-model="productList" height="auto" :paging="false" border v-if="orderDetail">
					<c-table-column label="服务信息" width="300">
						<template v-slot="{data}">
							<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
								:name="data.product_itemnumber + ' - '+data.product_name"
								image-size="30"></product-info>
							<product-info v-else :image="data.product_img_url" :name="data.product_name"
								image-size="30"></product-info>
						</template>
					</c-table-column>

					<!-- <c-table-column
                            label="规格名"
                            width="110"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_spec }}
                        </template>
                    </c-table-column> -->

					<!-- <c-table-column
                            label="服务SKU编码"
                            width="120"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_code ? data.product_sku_code : '-' }}
                        </template>
                    </c-table-column> -->

					<c-table-column label="成交单价">
						<template v-slot="{data}">
							<span v-if="orderDetail.order_state == 0 && !data.product_unit_price" style="color:brown">
								待报价
							</span>
							<span v-else>
								<span v-if="orderDetail.order_type == 2">
									￥{{parseFloat(data.product_unit_price||0).toFixed(2)}}
									+ {{data.points}}积分
								</span>
								<span v-else>
									￥{{parseFloat(data.product_unit_price).toFixed(2)}}
								</span>
								<font style="text-decoration: line-through;color:#999999;"
									v-if="data.product_unit_price!=data.original_product_price">
									<br />
									￥{{ parseFloat(data.original_product_price).toFixed(2)}}
								</font>
							</span>
						</template>
					</c-table-column>

					<c-table-column label="数量" width="80">
						<template v-slot="{data}">
							×{{ data.product_count }}
						</template>
					</c-table-column>

					<c-table-column label="折扣率" width="70" v-if="orderDetail.order_type != 2">
						<template v-slot="{data}">
							<span v-if="orderDetail.order_state == 0">
								--
							</span>
							<span v-else>
								{{ parseFloat(data.product_unit_price * data.product_count * 100 / data.original_product_money).toFixed(2) }}%
							</span>
						</template>
					</c-table-column>

					<c-table-column label="服务总额">
						<template v-slot="{data}">
							<span v-if="orderDetail.order_state == 0 && !data.product_money" style="color:brown">
								待报价
							</span>
							<span v-else>
								<span v-if="orderDetail.order_type == 2">
									￥{{parseFloat(data.product_money||0).toFixed(2)}}
									+{{parseFloat(data.points)*parseFloat(data.product_count)}}积分
								</span>
								<span v-else>
									￥{{parseFloat(data.product_money).toFixed(2)}}
								</span>

								<font style="text-decoration: line-through;color:#999999;"
									v-if="data.product_money!=data.original_product_money">
									<br />￥ {{parseFloat(data.original_product_money).toFixed(2)}}
								</font>
							</span>
						</template>
					</c-table-column>

					<!-- <c-table-column
                            label="未发退款数"
                    >
                        <template v-slot="{data}">
                            {{data.total_refund_count}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="已发退货数"
                    >
                        <template v-slot="{data}">
                            {{data.total_return_count}}
                        </template>
                    </c-table-column> -->

					<!-- <c-table-column
                            label="重量小计(克)"
                            width="100"
                    >
                        <template v-slot="{data}">
                            {{ data.product_weight ? data.product_weight : '-' }}
                        </template>
                    </c-table-column> -->

					<!-- <c-table-column
                            label="已发货数"
                            width="80"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.is_virtual == 0">{{ data.send_count }}</span>
                            <span v-if="data.is_virtual == 1 && orderDetail.payment_state == 3" style="color:darkgreen">已发放电子券码</span>
                            <span v-if="data.is_virtual == 1 && orderDetail.payment_state != 3" style="color:#999">支付后发放电子券码</span>
                        </template>
                    </c-table-column> -->
				</c-table>

				<div class="order-total flex-between-center">
					<div v-if="orderDetail.order_state != 0">
						￥{{ parseFloat(orderDetail.product_money).toFixed(2) }}（订单金额）
						<span v-if="orderDetail.order_type==7">
							+ ￥{{ parseFloat(cusTomInfo.product_price_money).toFixed(2) }}(定制费用)
						</span>
						<span v-if="orderDetail.logistics_money && orderDetail.logistics_money > 0">
							+ ￥{{ parseFloat(orderDetail.logistics_money).toFixed(2) }}(运费)
						</span>
						<span v-if="orderDetail.order_type == 2" style="color: magenta">
							+ {{orderDetail.points}} 积分
						</span>
						<span v-if="orderDetail.total_fee_money && orderDetail.total_fee_money > 0">
							+ ￥{{ parseFloat(orderDetail.total_fee_money).toFixed(2) }}(其他费用)
						</span>
					</div>
					<div v-if="orderDetail.order_state != 0" class="flex" style="gap: 20px;">
						<p>{{ orderDetail.payment_state == 1 ? '应付' : '已付' }}金额：<span><b>￥{{ paymentTotal }}</b></span></p>
						<span v-if="orderDetail.order_type == 2" style="font-size: 16px;color: magenta">
							+ {{orderDetail.points}} 积分
						</span>
						<dd
							v-if="orderDetail.payment_state == 2 && orderDetail.order_state != 5 && orderDetail.order_state != 6">
							待付尾款：<b>￥{{(parseFloat(orderDetail.product_money) - paymentTotal).toFixed(2)}}</b></dd>
					</div>
				</div>
				
				<dl v-if="orderHistoryList.length > 0">
					<dt>服务记录</dt>
					<dd class="service-record">
						<ul>
							<li v-for="(item, i) in orderHistoryList" :key="i">
								<p class="service-date">{{item.create_date}}
									<span>
										【{{userTypeName[item.user_type]}}】
									</span>
									<span v-if="item.user_type == 1 || item.user_type == 2 || item.user_type == 3">
										{{item.nick_name||'-'}}({{item.user_manage_mobilephone}})
									</span>
									<span v-if="item.user_type == 4 || item.user_type == 99">
										{{item.user_realname||'-'}}
									</span>
								</p>
								<p class="service-remark">{{item.remark}}</p>

								<div v-if="item.material_file && item.material_file.length" class="service-file">
									<div class="service-file-item flex-center-cross" v-for="(file, j) in parseMaterialFile(item.material_file)" :key="j" @click="previewFile(file)">
										<i :class="getFileIconClass(file.file_type)"></i>
										<p class="ellipsis">{{ file.file_name }}</p>
									</div>
								</div>
							</li>
						</ul>
					</dd>
				</dl>
				
				<dt v-if="orderRewardList.length > 0">结算明细</dt>
				<c-table v-model="orderRewardList" height="auto" :paging="false" border
					v-if="orderRewardList && orderRewardList.length > 0">
					<c-table-column label="结算流水号" name="record_number" width="120"></c-table-column>

					<c-table-column label="结算类型 " name="reward_type" width="100">
						<template v-slot="row">
							{{rewardTypeName[row.data.reward_type]}}
						</template>
					</c-table-column>

					<c-table-column label="结算对象 " name="user_type" width="150">
						<template v-slot="row">
							<span v-if="row.data.user_type==1"><span style="color:darkgreen">（代理）</span>{{row.data.reward_nick_name}}</span>
							<span v-if="row.data.user_type==2"><span style="color:#2348d0">（商家）</span>{{row.data.company_name}}</span>
							<span v-if="row.data.user_type==3" style="color:red">（平台）</span>
						</template>
					</c-table-column>

					<c-table-column label="结算占比" name="record_ratio" width="90">
						<template v-slot="row">
							{{parseFloat((parseFloat(row.data.record_ratio)*100).toFixed(2))}}%
						</template>
					</c-table-column>

					<c-table-column label="可结算金额" name="estimated_record_money" width="90">
						<template v-slot="row">
							<span
								style="color:blue;">¥{{parseFloat(parseFloat(row.data.estimated_record_money).toFixed(2))}}</span>
						</template>
					</c-table-column>

					<c-table-column label="预计最终结算金额" name="original_record_money" width="130">
						<template v-slot="row">
							<span
								style="color:gray;">¥{{parseFloat(parseFloat(row.data.original_record_money).toFixed(2))}}</span>
						</template>
					</c-table-column>

					<c-table-column label="已结算金额" name="record_money" width="100">
						<template v-slot="row">
							<span v-if="row.data.state == 2" style="color:green;">
								¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
							</span>
							<span v-else>-</span>
						</template>
					</c-table-column>

					<c-table-column label="结算状态" name="state" width="75">
						<template v-slot="{data}">
							<span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
							<span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
							<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
						</template>
					</c-table-column>

					<c-table-column label="结算说明" name="remark" width="270"></c-table-column>

					<c-table-column label="生成时间" name="create_date" width="140"></c-table-column>

					<c-table-column label="最近更新时间" name="update_date" width="140"></c-table-column>

					<c-table-column label="取消时间" name="cancel_date" width="140">
						<template v-slot="{data}">
							<span v-if="data.cancel_date && data.state==0"
								style="color:darkgray">{{data.cancel_date}}</span>
							<span v-else>-</span>
						</template>
					</c-table-column>

					<c-table-column label="取消原因" name="reject_reason" width="140">
						<template v-slot="{data}">
							<span v-if="data.reject_reason && data.state==0"
								style="color:darkgray">{{data.reject_reason}}</span>
							<span v-else>-</span>
						</template>
					</c-table-column>
				</c-table>

				<dt v-if="reducedList && reducedList.length > 0">优惠信息</dt>
				<c-table v-if="reducedList && reducedList.length > 0" v-model="reducedList" height="auto" :paging="false" border>
					<c-table-column label="优惠类型" width="100">
						<template v-slot="{data}">
							{{ reducedTypeName[data.reduced_type] }}
						</template>
					</c-table-column>

					<c-table-column label="优惠金额" width="100">
						<template v-slot="{data}">
							<span v-if="data.reduced_money<=0" style="color:red">￥{{ data.reduced_money }}</span>
							<span v-else style="color:green">￥ {{ data.reduced_money }}</span>
						</template>
					</c-table-column>

					<c-table-column label="优惠承担方" width="110">
						<template v-slot="{data}">
							<span>{{ carryTypeName[data.carry_type] }}</span>
						</template>
					</c-table-column>

					<c-table-column label="备注" width="300">
						<template v-slot="{data}">
							<span>
								{{ data.remark }}
							</span>
						</template>
					</c-table-column>

					<c-table-column type="button" fixed="right" label="操作" width="100">
						<template v-slot="{data}">
							<c-table-button @click="reducedDetail(data.id,data.remark)">优惠明细</c-table-button>
						</template>
					</c-table-column>
				</c-table>

        <dt v-if="refundOrderList.length>0">关联未发退款单</dt>
        <c-table v-model="refundOrderList" height="auto" :paging="false" border v-if="refundOrderList.length>0">
          <c-table-column label="状态" name="state" width="85">
            <template v-slot="{data}">
							<span style="color:#182eff"
                    v-if="data.state==1">{{ refundOrderStateName[data.state] }}</span>
              <span style="color:darkgreen"
                    v-if="data.state==2">{{ refundOrderStateName[data.state] }}</span>
              <span style="color:gray" v-if="data.state==3">{{ refundOrderStateName[data.state] }}</span>
              <span style="color:gray" v-if="data.state==4">{{ refundOrderStateName[data.state] }}</span>
            </template>
          </c-table-column>

          <c-table-column label="退款单号" name="refund_number" width="130"></c-table-column>

          <c-table-column label="退款类型" name="refund_type" width="80">
            <template v-slot="{data}">
							<span v-if="data.refund_type==1"
                    style="color:#888888">{{ refundTypeName[data.refund_type] }}</span>
              <span v-if="data.refund_type==2"
                    style="color:#ff00ff">{{ refundTypeName[data.refund_type] }}</span>
              <span v-if="data.refund_type==3"
                    style="color:#000000">{{ refundTypeName[data.refund_type] }}</span>
            </template>
          </c-table-column>

          <c-table-column label="服务退款" name="product_money">
            <template v-slot="{data}">
							<span style="color:blue"
                    v-if="data.product_money&&data.product_money>0">￥{{ data.product_money.toFixed(2) }}</span>
              <span v-else>--</span>
            </template>
          </c-table-column>

          <c-table-column label="退款总额" name="refund_total_money">
            <template v-slot="{data}">
							<span style="color:blue"
                    v-if="data.refund_total_money&&data.refund_total_money>0">￥{{ data.refund_total_money.toFixed(2) }}</span>
              <span v-else>--</span>
            </template>
          </c-table-column>

          <c-table-column label="申请时间" name="create_date" width="150"></c-table-column>

          <c-table-column type="button" fixed="right" label="操作">
            <template v-slot="{data}">
              <c-table-button
                  @click="navigateTo({path: `/refund_detail/${data.refund_number}`, query: {refundType: data.refund_type}})">
                查看
              </c-table-button>
            </template>
          </c-table-column>
        </c-table>

				<div class="flex-between">
					<dl class="order-info flex-grow">
						<dt>交易信息</dt>
						<dd>
							<div class="order-info-item flex">
								<label>订单编号：</label>
								<p>
									{{ orderDetail.order_number }}
								<div class="tag"
									v-if="orderDetail.order_classify == 1 && systemConfig.is_virtual_product == 'ON'"
									style="background: #00B2FB">实物</div>
								<div class="tag"
									v-if="orderDetail.order_classify == 2 && systemConfig.is_virtual_product == 'ON'"
									style="background: #FFDE00">虚拟</div>
								<div class="tag" v-if="orderDetail.is_cloud_stock == 1 && systemConfig.cloud_stock == 'ON'"
									style="background: #057215">囤货</div>
								<div class="tag" v-if="orderDetail.order_type!=1" style="background: #4686e0">
									{{ orderTypeName[orderDetail.order_type] }}
								</div>
								<a @click="clipboard(orderDetail.order_number)" style="color: blue">&nbsp;复制单号</a>
								</p>
							</div>
							<div class="order-info-item flex"
								v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'">
								<label>运营模式：</label>
								<p>{{ operationModeName[orderDetail.operation_mode] }}</p>
							</div>
							<div class="order-info-item flex"
								v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'">
								<label>商家角色：</label>
								<p>{{ orderDetail.stationed_auth_name }}</p>
							</div>
							<div class="order-info-item flex" v-if="systemConfig.pt_mode == 2">
								<label>所属商家：</label>
								<p>{{ orderDetail.stationed_name }}</p>
							</div>
							<div class="order-info-item flex">
								<label>下单时间：</label>
								<p>{{ orderDetail.create_date }} <!-- <a>更多</a> --></p>
							</div>
							<div class="order-info-item flex">
								<label>付款状态：</label>
								<p>{{ paymentState }}</p>
							</div>
							<div class="order-info-item flex">
								<label>付款方式：</label>
								<p>{{ orderDetail.payment_type ? orderDetail.payment_type : '-' }}</p>
							</div>
							<div class="order-info-item flex" v-if="orderDetail.payment_type=='转账支付'">
								<label>付款凭证：</label>
								<c-image v-if="orderDetail.pay_voucher_url" :src="orderDetail.pay_voucher_url" size="20"
									preview></c-image>
								<span v-else>-</span>
							</div>
						</dd>
					</dl>
				
					<dl class="order-info flex-grow">
						<dt>专业代理信息</dt>
						<dd>
							<div class="order-info-item flex">
								<span v-if="orderDetail.prof_agency_state != 0 && (orderDetail.payment_state == 2 || orderDetail.payment_state == 3 )">
									<span v-if="orderDetail.prof_agency_state == 1" style="color:blue;">待邀请专业代理</span>
									<span v-else-if="orderDetail.prof_agency_state == 2"
										style="color: orange;">等待专业代理接单</span>
									<span v-else-if="orderDetail.prof_agency_state == 3" style="color:red;">专业代理拒绝接单</span>
									<span v-else-if="orderDetail.prof_agency_state == 4" style="color:green;">专业代理已接单</span>
				
				                    <span v-if="(orderDetail.prof_agency_state == 1 || orderDetail.prof_agency_state == 2 || orderDetail.prof_agency_state == 3)
				                                && auth('b_retail_invite_prof_user')
				                                && orderDetail.order_state != 5
				                                && orderDetail.order_state != 6
				                                && orderDetail.order_state != 12"
				                          name="邀请专业代理" type="primary" style="margin-left: 5px; cursor: pointer;color:black" @click="showProfAgencyDialog(data)">
				                        👉邀请
				                   </span>
								</span>
								<span v-else>-</span>
							</div>
							<div class="order-info-item flex">
								<label>手机号：</label>
								<p
									v-if="orderDetail.prof_agency_state != 0 && orderDetail.prof_agency_state != 1 && (orderDetail.payment_state == 2 || orderDetail.payment_state == 3 ) && orderDetail.order_state != 6">
									{{orderDetail.prof_manage_mobilephone}}
								</p>
								<span v-else>-</span>
							</div>
							<div class="order-info-item flex">
								<label>昵称：</label>
								<p
									v-if="orderDetail.prof_agency_state != 0 && orderDetail.prof_agency_state != 1 && (orderDetail.payment_state == 2 || orderDetail.payment_state == 3 ) && orderDetail.order_state != 6">
									{{ orderDetail.prof_nick_name ? orderDetail.prof_nick_name : '-' }}
								</p>
								<span v-else>-</span>
							</div>
						</dd>
					</dl>
				
					<dl class="order-info flex-grow">
						<dt>买家信息</dt>
						<dd>
							<div class="order-info-item flex">
								<label>头像：</label>
								<c-image :src="orderDetail.head_photo" preview size="30"
									style="margin-right: 10px;"></c-image>
							</div>
							<div class="order-info-item flex">
								<label>昵称：</label>
								<p>{{ orderDetail.nick_name ? orderDetail.nick_name : '-' }}</p>
							</div>
							<!--                        <div class="order-info-item flex">
				                <label>会员名：</label>
				                <p>{{ orderDetail.user_login_name }}</p>
				            </div>-->
							<div class="order-info-item flex">
								<label>手机号：</label>
								<p>{{ orderDetail.user_manage_mobilephone }}</p>
							</div>
							<div class="order-info-item flex">
								<label>服务区域：</label>
								<p>{{ orderDetail.receiving_address }}</p>
							</div>
							<!--                        <div class="order-info-item flex">
				                <label>所属业务员：</label>
				                <p>{{ orderDetail.salesman_realname ? orderDetail.salesman_realname : '&#45;&#45;' }}</p>
				            </div>-->
							<div class="order-info-item flex">
								<label>买家留言：</label>
								<p>{{ orderDetail.order_remark ? orderDetail.order_remark : '-' }}</p>
							</div>
							<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
								<label>定制附件：</label>
								<p class="flex">
									<template v-if="cusTomInfo.custom_attach_url">
										<c-image v-for="(item, i) in cusTomInfo.custom_attach_url.split(',')" :key="i"
											:src="item" size="50" preview style="margin-right: 10px;"></c-image>
									</template>
								</p>
							</div>
							<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
								<label>定制备注：</label>
								<p>{{ cusTomInfo.custom_remark ? cusTomInfo.custom_remark : '-' }}</p>
							</div>
						</dd>
					</dl>
					
					<dl v-if="invoiceInfo" class="order-info flex-grow">
						<dt>开票信息</dt>
						<dd>
							<div class="order-info-item flex">
								<label>发票类型：</label>
								<p v-if="invoiceInfo.invoice_type == 1">普通发票</p>
								<p v-else-if="invoiceInfo.invoice_type == 2">增值税专用发票</p>
								<p v-else-if="invoiceInfo.invoice_type == 3">增值税专用发票13%</p>
							</div>
							<div class="order-info-item flex">
								<label>纳税人识别号：</label>
								<p>{{ invoiceInfo.tax_number }}</p>
							</div>
							<div class="order-info-item flex">
								<label>开户行账号：</label>
								<p v-if="invoiceInfo.invoice_type != 1">
									{{ invoiceInfo.bank_account }}（开户行{{ invoiceInfo.bank_name }}）</p>
								<p v-else>--</p>
							</div>
							<div class="order-info-item flex">
								<label>开票地址：</label>
								<p v-if="invoiceInfo.invoice_type != 1">{{ invoiceInfo.kp_address || '-' }}</p>
								<p v-else>--</p>
							</div>
							<div class="order-info-item flex">
								<label>开票电话：</label>
								<p v-if="invoiceInfo.invoice_type != 1">{{ invoiceInfo.kp_phone || '-' }}</p>
								<p v-else>--</p>
							</div>
							<div class="order-info-item flex">
								<label>发票抬头：</label>
								<p>{{ invoiceInfo.invoice_title }}</p>
							</div>
							<div class="order-info-item flex">
								<label>联系人：</label>
								<p>{{ invoiceInfo.contact_name || '-' }}</p>
							</div>
							<div class="order-info-item flex">
								<label>联系电话：</label>
								<p>{{ invoiceInfo.contact_phone || '-' }}</p>
							</div>
							<div class="order-info-item flex">
								<label>邮箱：</label>
								<p>{{ invoiceInfo.email || '-' }}</p>
							</div>
							<div class="order-info-item flex">
								<label>收票地址：</label>
								<p>{{ invoiceAddress || '-' }}</p>
							</div>
							<div class="order-info-item flex">
								<label>开票状态：</label>
								<p v-if="orderDetail.invoice_state == 2" style="color: green">已开票</p>
								<p v-if="orderDetail.invoice_state == 1" style="color: red">未开票</p>
							</div>
							<div class="order-info-item flex">
								<label>开票完成时间：</label>
								<p v-if="orderDetail.invoice_state == 2">{{ orderDetail.invoice_date }}</p>
								<p v-else>--</p>
							</div>
							<div class="order-info-item flex">
								<label>开票实收金额：</label>
								<p style="font-size:20px;color: green" v-if="orderDetail.invoice_state == 2">
									￥{{ parseFloat(orderDetail.reality_money).toFixed(2) }}</p>
								<p v-else>--</p>
							</div>
							<div class="order-info-item flex">
								<label>开票凭证：</label>
								<p v-if="orderDetail.invoice_state == 2">
									<c-image v-if="orderDetail.invoice_file_type == 1" :src="orderDetail.invoice_file"
										size="80" preview></c-image>
									<a v-if="orderDetail.invoice_file_type == 2" :href="orderDetail.invoice_file"
										target="_blank">{{ orderDetail.invoice_file }}</a>
								</p>
								<p v-else>--</p>
							</div>
						</dd>
					</dl>
				</div>
			</div>

			<template slot="button">
				<c-button
					v-if="(auth('b_order_edit_price') || auth('b_retail_order_edit_price')) && orderDetail.order_state == 1 && orderDetail.order_state == 2 && orderDetail.payment_state == 1 && orderDetail.order_type != 2"
					size="m" hollow @click="orderEditPriceHandle()">调价
				</c-button>
				<c-button
					v-if="(auth('b_order_check') || auth('b_retail_order_check') || auth('b_cash_order_approve')) && orderDetail.order_state != 0 && orderDetail.order_state != 6 && orderDetail.check_state == 1"
					size="m" @click="checkHandle('pass')">审核通过
				</c-button>
				<c-button
					v-if="(auth('b_order_check') || auth('b_retail_order_check') || auth('b_cash_order_approve')) && orderDetail.order_state != 0 && orderDetail.order_state != 6 && orderDetail.check_state == 1"
					size="m" color="red" @click="checkHandle('reject')">审核驳回
				</c-button>
				<c-button color="sys"
					v-if="
                orderDetail.is_to_platform > 0
                && (orderDetail.order_type != 10 ||(orderDetail.order_type == 10 && orderDetail.receive_state == 1))
                && orderDetail.is_cloud_stock == 0
                && (auth('b_order_deliver') || auth('b_retail_order_deliver'))
                && ((orderDetail.order_type == 8 && orderDetail.group_achieve == 1)||(orderDetail.order_type != 8))
                && orderDetail.operation_mode == 1 && orderDetail.refunding_count==0
                && orderDetail.returning_count==0 && orderDetail.check_state == 2
                && (orderDetail.order_state == 2 || (orderDetail.order_state == 3 && orderDetail.deliver_state =='部分发货'))" size="m"
					@click="$refs.orderProductSend.open(orderDetail.order_number)">发货
				</c-button>
				<c-button v-if="(auth('b_customer_service_remark') || auth('b_retail_order_customer_service_remark'))"
					size="m" hollow @click="orderRemarkHandle()">客服备注
				</c-button>
				<c-button v-if="(auth('b_customer_service_remark') || auth('b_retail_order_customer_service_remark'))"
					size="m" hollow @click="showRemarkList">查看客服备注
				</c-button>
				<c-button
					v-if="orderDetail.is_cloud_stock == 0 && (auth('b_order_deliver') || auth('b_retail_order_deliver')) && orderDetail.operation_mode == 1 && (orderDetail.order_state == 1 || orderDetail.order_state == 2) && orderDetail.push_state != 2"
					size="m" hollow @click="$refs.editOrderAddress.open(orderDetail.order_number)">修改收货信息
				</c-button>
				<c-button v-if="orderDetail.check_state==2
                                && (auth('b_order_close') || auth('b_retail_order_close'))
                                && orderDetail.is_to_platform > 0
                                && orderDetail.refunding_count==0 && orderDetail.returning_count==0
                                && (orderDetail.payment_state == 1 || (
                                      orderDetail.order_state == 2 && orderDetail.order_type != 2 && orderDetail.order_type != 3 && orderDetail.order_type != 11
                                  ))" size="m" hollow @click="closeHandle()">关闭订单
				</c-button>
				<c-button
					v-if="(auth('b_order_update_remark') || auth('b_retail_order_update_remark')) && orderDetail.order_state <= 2"
					@click="reMarkHandle()" size="m" hollow>修改买家留言
				</c-button>
				<c-button
					v-if="orderDetail.check_state==2 && orderDetail.is_cloud_stock == 0 && (auth('b_order_invoice_finish') || auth('b_retail_order_invoice_finish')) && systemConfig.order_invoice_enabled == 'ON' && orderDetail.check_state == 2 && orderDetail.invoice_state == 1 && (orderDetail.order_state == 3 || orderDetail.order_state == 5) && invoiceInfo !=null "
					size="m" hollow @click="onInvoiceFinish()">开票完成
				</c-button>
				<c-button
					v-if="orderDetail.check_state==2 && orderDetail.is_cloud_stock == 0 && (auth('b_order_detail') || auth('b_retail_order_detail')) && systemConfig.express_query_enabled == 'ON' && (orderDetail.order_state == 3 || orderDetail.order_state == 5)"
					size="m" hollow @click="showLogistics">查看物流
				</c-button>
			</template>
		</module>

		<!--订单调价 -->
		<c-dialog ref="orderEditPrice" title="订单调价" width="950" button-name="确定调价" @resolve="orderEditPriceHandle">
			<c-table ref="orderEditList" v-model="editList" height="350" :paging="false">
				<c-table-column label="服务信息" width="300">
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
							:name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"
							image-size="60"></product-info>
					</template>
				</c-table-column>

				<c-table-column label="规格信息" name="product_sku_spec" width="120"></c-table-column>

				<c-table-column label="服务SKU编码" width="120">
					<template v-slot="{data}">
						{{ data.product_sku_code ? data.product_sku_code : '-' }}
					</template>
				</c-table-column>

				<c-table-column label="原单价" width="80">
					<template v-slot="{data}">
						￥{{ parseFloat(data.original_unit_money).toFixed(2) }}
					</template>
				</c-table-column>

				<c-table-column label="服务数量" width="80">
					<template v-slot="{data}">
						×{{ data.product_count }}
					</template>
				</c-table-column>

				<c-table-column label="现单价" width="90">
					<template v-slot="{data}">
						<div class="flex-center-cross">
							￥
							<c-input v-model="data.product_unit_price" type="number" :limit="999999" decimal="2"
								width="60"></c-input>
						</div>
					</template>
				</c-table-column>

				<c-table-column label="成交小计" width="100">
					<template v-slot="{data}">
						￥{{ (data.product_count * (parseFloat(data.product_unit_price) || 0)).toFixed(2) }}
					</template>
				</c-table-column>
			</c-table>
			<div class="order-price_total flex-between-center" style="padding:10px; background-color: #efefef;"
				v-if="orderDetail.operation_mode == 1">
				<div>调价后服务总额：￥<span><b>{{ parseFloat(newProductMoney).toFixed(2) }}</b></span>
					<span v-if="orderDetail.order_type==7">，定制费用
						￥{{ parseFloat(cusTomInfo.product_price_money).toFixed(2) }}</span>，
					运费 ￥
					<c-input v-model="new_logistics_money" type="number" :limit="999999" decimal="2"
						width="60"></c-input> <!-- ，其他收费￥{{parseFloat(orderDetail.total_fee_money).toFixed(2)}} -->
				</div>
				<div>
					调价后应付总额：<span><b>￥{{ (newProductMoney + (cusTomInfo.product_price_money || 0) + parseFloat(new_logistics_money || 0)).toFixed(2) }}</b></span>
				</div>
			</div>
		</c-dialog>

		<!--物流信息查询弹框 -->
		<c-dialog ref="logistics" title="物流信息" width="900" :button="false">
			<div class="logistics">
				<div class="logistics-order-scroll">
					<ul class="logistics-order flex" v-show="express_list">
						<li v-for="(item, i) in express_list" :key="i" :class="{'z-crt': item == crtExpress}"
							@click="crtExpress = item">
							<p>{{ item.logistics_company }}【{{ item.logistics_number }}】</p>
						</li>
					</ul>
				</div>
				<ul v-if="crtExpress" class="logistics-list">
					<li v-for="(item, i) in crtExpress.track" :key="i" class="flex">
						<p>{{ item.time }}</p>
						<p class="flex-grow" style="margin-left: 20px;">{{ item.status }}</p>
					</li>
				</ul>
				<ul v-else class="logistics-list">
					暂无轨迹数据
				</ul>
			</div>
		</c-dialog>

		<!--客服备注弹框（输入） -->
		<c-dialog ref="orderRemark" title="客服备注" width="700" @resolve="orderRemarkHandle">
			<div class="order-remark">
				<textarea v-model="orderRemark" placeholder="请输入备注内容..."></textarea>
			</div>
		</c-dialog>

		<!--客服备注弹框（列表） -->
		<c-dialog ref="remarkList" title="客服备注" width="700" :button="false">
			<c-table v-model="remarkList" height="400" :paging="false" border>
				<c-table-column label="备注人" name="create_user_realname" width="80"></c-table-column>

				<c-table-column label="备注内容" name="customer_service_remark" width="280"></c-table-column>

				<c-table-column label="备注时间" name="create_date"></c-table-column>
			</c-table>
		</c-dialog>

		<!--审核驳回原因弹框 -->
		<c-dialog ref="rejectReason" title="不通过原因" width="550" button-name="审核驳回" @resolve="rejectHandle">
			<div class="order-remark">
				<textarea v-model="rejectReason" placeholder="请输入不通过原因..."></textarea>
			</div>
		</c-dialog>

		<!--关闭订单弹框-->
		<c-dialog ref="closeDia" title="关闭订单" width="600" @resolve="closeHandle">
			<div class="order-remark">
				<textarea v-model="cancel_reason" placeholder="请输入取消原因..."></textarea>
			</div>
		</c-dialog>

		<!--修改买家留言弹框-->
		<c-dialog ref="reMarkDia" title="修改买家留言" width="600" @resolve="reMarkHandle">
			<div class="order-remark">
				<textarea v-model="order_remark" placeholder="请买家留言..."></textarea>
			</div>
		</c-dialog>

		<!--开票完成弹框-->
		<c-dialog ref="invoiceConf" title="开票确认" button-name="确认开票完成" width="500" height="360"
			@resolve="submitInvoiceFinish">
			<c-form>
				<div class="invoice">
					<p v-html="text_msg"></p>
					<!-- <c-datetime label="开票时间" v-model="invoiceDate" type="date"></c-datetime> -->
					<c-form-item type="datetime" v-model="invoiceDate" label="开票时间"></c-form-item>
					<c-form-item type="number" v-model="realityMoney" :limit="9999999" decimal="2"
						label="实收金额"></c-form-item>
					<c-form-item type="radio" label="开票凭证" name="invoice_file_type" v-model="invoice_file_type"
						:options="invoiceFileType"></c-form-item>
					<c-form-item type="file" v-if="invoice_file_type == 1" label="附件" v-model="invoice_file"
						name="invoice_file" file-type="image,pdf"></c-form-item>
					<c-form-item type="input" v-if="invoice_file_type == 2" label="链接" v-model="invoice_file"
						word="http://或https://开头" name="invoice_file"></c-form-item>
				</div>
			</c-form>
		</c-dialog>

		<!--优惠明细-->
		<c-dialog ref="reducedDetailDialog" :title="reducedDetailTitle" width="900">
			<c-table ref="reducedDetailList" v-model="reducedDetailList" height="350" :paging="false">
				<c-table-column label="服务信息" width="300">
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
							:name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"
							image-size="60"></product-info>
					</template>
				</c-table-column>

				<c-table-column label="规格信息" name="product_sku_spec" width="120"></c-table-column>

				<c-table-column label="服务数量" width="80">
					<template v-slot="{data}">
						×{{ data.product_count }}
					</template>
				</c-table-column>

				<c-table-column label="优惠金额" width="100">
					<template v-slot="{data}">
						<span v-if="data.reduced_money<=0"
							style="color:red">￥{{ (parseFloat(data.reduced_money) || 0).toFixed(2) }}</span>
						<span v-else style="color:green">￥{{ (parseFloat(data.reduced_money) || 0).toFixed(2) }}</span>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		<!--修改订单收货地址弹窗-->
		<edit-order-address ref="editOrderAddress" @resolve="getOrderDetail()"></edit-order-address>
		<order-product-send ref="orderProductSend" @resolve="getOrderDetail()"></order-product-send>
        <member-prof-agency-selector ref="memberProfAgencySelector"  :multiple="false" @resolve="selectProfAgencyHandle($event)"></member-prof-agency-selector>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'

	import {
		mapState
	} from 'vuex'
	import {
		mapGetters
	} from 'vuex'
	import nodeList from '@/components/public/node_list.vue'
	import editOrderAddress from "@/components/service/order_address_edit.vue";
	import orderProductSend from "@/components/service/order_product_send.vue";
    import memberProfAgencySelector from "@/components/service/member_prof_agency_selector.vue";

	export default {
		name: 'order_detail',

		components: {
            memberProfAgencySelector,
			nodeList,
			orderProductSend,
			editOrderAddress,
			productInfo
		},

		props: {
			orderNumber: String
		},

		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				reducedList: [],
				cusTomList: [],
				cusTomInfo: '',
				invoiceInfo: '',
				invoiceDate: '',
				realityMoney: 0,
				sendList: [],
				editList: [],
				logisticsCompany: [],
				sendNum: {},
				orderRemark: '',
				remarkList: [],
				rejectReason: '',
				cancel_reason: '',
				order_remark: '',
				pack_info: [],
				new_logistics_money: 0,
				old_money: 0,
				invoice_file_type: '', //开票文件类型
				invoice_file: '', //发票文件
				invoiceFileType: [{
					name: '附件',
					value: 1
				}, {
					name: '链接',
					value: 2
				}],
				text_msg: '',
				reducedTypeName: {
					0: '代理卡礼包',
					1: '优惠券',
					2: '限时折扣活动优惠',
					3: '代理等级折扣优惠',
					4: '砍价活动优惠',
					5: '抽奖奖品优惠',
					6: '积分抵扣',
					7: '秒杀活动优惠',
					8: '预售活动优惠',
					9: '拼团活动优惠',
					10: '特殊价格优惠',
					11: '新人活动',
					99: '订单调价'
				},
				express_list: [], //物流轨迹
				crtExpress: null,
				refundOrderList: [],
				returnOrderList: [],
				refundOrderStateName: {
					1: '待审核',
					2: '审核通过',
					3: '已驳回',
					4: '已撤销'
				},
				refundTypeName: {
					1: '整单取消',
					2: '部分退款',
					3: '定金退款'
				},
				returnOrderStateName: {
					1: '待审核',
					2: '待会员退货',
					3: '待财务打款',
					5: '退款成功',
					6: '已驳回',
					8: '已撤销'
				},
				operationModeName: {
					1: '平台自营',
					2: '商家自营',
					3: '采购供货'
				},
				orderTypeName: {
					1: '普通',
					2: '积分',
					3: '升级赠品',
					4: '砍价',
					5: '预定(全款)',
					6: '预定(定金)',
					7: '定制',
					8: '拼团',
					9: '云仓提货',
					10: '送礼',
					11: '抽奖'
				},
				carryTypeName: {
					1: '平台承担',
					2: '商家承担',
					3: '平台/商家共同承担'
				},
				reducedDetailList: [],
				orderFlowList: [],
				orderRewardList: [],
				orderHistoryList: [],
				userTypeName: {
					1: '平台会员',
					2: '爆款代理',
					3: '专业代理',
					4: '服务商',
					99: '平台'
				},
				reducedDetailTitle: '优惠明细',
				transStateName: {
					0: '取消结算',
					1: '待结算',
					2: '已结算'
				},
				rewardTypeName: {
					2: '直推奖励',
					3: '间推奖励',
					201: '爆款代理费',
					202: '专业代理费',
					203: '市代代理费',
					204: '省代代理费',
					205: '业务员代理费',
					206: '平台服务费',
					207: '商家货款'
				},
			}
		},

		computed: {
			...mapState(['systemConfig']),
			...mapGetters({
				auth: 'power'
			}),

			checkState() {
				return {
					1: this.orderDetail.order_state == 6 ? '' : '（待审核）',
					2: this.orderDetail.order_state == 6 || this.orderDetail.order_state == 1 ? '' : '（审核通过' + (this
						.orderDetail.push_state == 1 ? '' : '') + '）',
					3: '（审核驳回）',
				} [this.orderDetail.check_state];
			},

			orderState() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0) {
					msg = "订单申请【未发退款】";
				} else if (this.orderDetail.returning_count > 0) {
					msg = "订单申请【已发退货】";
				} else if (this.orderDetail.order_state == 0) {
					msg = "订单待报价";
				} else if (this.orderDetail.order_state == 12) {
                    msg = "订单服务终止";
                } else if (this.orderDetail.order_state == 2 && this.orderDetail.order_type == 10 && this.orderDetail
					.receive_state == 0) {
					msg = "待好友领取礼物";
				} else {
					if (this.orderDetail.order_classify == 1) {
						var sendTip = '买家已付款，等待商家发货';
						if (this.orderDetail.order_type == 8) { //拼团
							if (this.orderDetail.group_achieve == 1) { //已经成团
								sendTip = '拼团活动已成团，等待商家发货';
							} else {
								sendTip = '拼团活动尚未成团，待成团后发货';
							}
						}
						msg = {
							1: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason + ')' :
								'等待买家付款',
							2: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason + ')' :
								'买家已付款，等待商家开始服务',
							3: '商家服务进行中',
							4: '已服务完成，待客户验收',
							5: '客户已验收，交易成功',
							6: this.orderDetail.check_state == 3 ? '审核不通过' : '订单已取消'
						} [this.orderDetail.order_state];
					} else {
						var sendTip = '买家已付款，等待发放卡券';
						if (this.orderDetail.order_type == 8) { //拼团
							if (this.orderDetail.group_achieve == 1) { //已经成团
								sendTip = '拼团活动已成团，等待发放卡券';
							} else {
								sendTip = '拼团活动尚未成团，待成团后发放卡券';
							}
						}
						msg = {
							1: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason + ')' :
								'等待买家付款',
							2: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason + ')' :
								'买家已付款，等待商家开始服务',
							3: '商家服务进行中',
							4: '已服务完成，待客户验收',
							5: '客户已验收，交易成功',
							6: this.orderDetail.check_state == 3 ? '审核不通过' : '订单已取消'
						} [this.orderDetail.order_state];
					}
				}
				return msg;
			},

			orderStateWord() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0) {
					msg = "订单存在【未发退款】申请，请先处理完成后再进行其他操作";
				} else if (this.orderDetail.returning_count > 0) {
					msg = "订单存在【已发退货】申请，请先处理完成后再进行其他操作";
				} else if (this.orderDetail.order_state == 0) {
					msg = "当前服务需要价格面议，待服务商对订单进行报价";
				} else if (this.orderDetail.order_state == 12) {
                    msg = "当前订单已完成退款，订单服务终止";
                } else if (this.orderDetail.order_state == 2 && this.orderDetail.order_type == 10 && this.orderDetail
					.receive_state == 0) {
					msg = "待好友领取礼物，完善收货地址等信息";
				} else {
					if (this.orderDetail.order_state == 1 && this.orderDetail.payment_state == 2) {
						msg = "等待买家支付尾款";
					} else {
						if (this.orderDetail.order_classify == 1) {
							var sendTip = '买家已付款，请尽快发货';
							if (this.orderDetail.order_type == 8) { //拼团
								if (this.orderDetail.group_achieve == 1) { //已经成团
									sendTip = '拼团活动已成团，请尽快发货';
								} else {
									sendTip = '拼团活动尚未成团，待成团后发货';
								}
							}
							msg = {
								1: this.orderDetail.payment_type == '转账支付' ? '当前订单使用转账支付，请及时审核' : '请在 ' + this
									.orderDetail.last_pay_date + ' 之前完成支付，否则订单将自动取消',
								2: '买家已付款，请尽快开始服务',
								3: '商家服务进行中，当前服务中的项目：【' + this.orderDetail.order_flow_info.flow_name + '】',
								4: '商家已完成全部服务，待客户验收',
								5: '客户于：' + this.orderDetail.confirm_date + '完成验收，订单交易成功',
								6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail
									.cancel_reason_type_name : '') + (this.orderDetail.cancel_reason ? '（' + this
									.orderDetail.cancel_reason + '）' : '')
							} [this.orderDetail.order_state];
						} else {
							var sendTip = '买家已付款，请尽快发货';
							if (this.orderDetail.order_type == 8) { //拼团
								if (this.orderDetail.group_achieve == 1) { //已经成团
									sendTip = '拼团活动已成团，请尽发放卡券';
								} else {
									sendTip = '拼团活动尚未成团，待成团后发放卡券';
								}
							}
							msg = {
								1: this.orderDetail.payment_type == '转账支付' ? '当前订单使用转账支付，请及时审核' : '请在 ' + this
									.orderDetail.last_pay_date + ' 之前完成支付，否则订单将自动取消',
								2: '买家已付款，请尽快开始服务',
								3: '商家服务进行中，当前服务中的项目：【' + this.orderDetail.order_flow_info.flow_name + '】',
								4: '商家已完成全部服务，待客户验收',
								5: '客户于：' + this.orderDetail.confirm_date + '完成验收，订单交易成功',
								6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail
									.cancel_reason_type_name : '') + (this.orderDetail.cancel_reason ? '（' + this
									.orderDetail.cancel_reason + '）' : '')
							} [this.orderDetail.order_state];
						}
					}
				}
				return msg;
			},

			paymentState() {
				return {
					1: '待付款',
					2: '待付尾款',
					3: '已付款'
				} [this.orderDetail.payment_state];
			},

			paymentTotal() {
				if (this.orderDetail.order_type == 7) {
					return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money || 0).toFixed(2) : (this
						.orderDetail.product_money + this.cusTomInfo.product_price_money + this.orderDetail
						.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
				} else {
					if (this.orderDetail.payment_state == 2 || this.orderDetail.payment_state == 3) {
						return (this.orderDetail.payment_money || 0).toFixed(2);
					} else {
						return (this.orderDetail.product_money + this.orderDetail.logistics_money + this.orderDetail
							.total_fee_money).toFixed(2);
					}
				}
			},

			newProductMoney() {
				var total_product_money = 0;
				this.editList.forEach(item => {
					total_product_money += (parseFloat(item.product_unit_price) || 0) * item.product_count;
				});
				return total_product_money;
			},

			invoiceAddress() {
				if (!this.invoiceInfo) return '';
				return (this.invoiceInfo.address_province_name || '') + (this.invoiceInfo.address_city_name || '') + (this
					.invoiceInfo.address_county_name || '') + (this.invoiceInfo.address_details || '');
			},

			nodeList() {
				var resultNodeList = this.orderFlowList.map(item => {
					var obj = {};
					obj.name = item.name;
                    obj.current = (item.state != 2);
					return obj;
				});
				return resultNodeList;
			}
		},

		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},

		mounted() {
			this.getOrderDetail();
		},

		methods: {
			//获取订单详情数据
			getOrderDetail() {
				this.request({
					url: '/order/detail',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
						this.giftProductList = data.gift_product_list;
						this.reducedList = data.reduced_list;
						this.cusTomList = data.custom_list || [];
						this.cusTomInfo = data.custom_info || {};
						this.invoiceInfo = data.invoice_info;
						this.pack_info = data.pack_info;
						this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail
							.payment_money || 0).toFixed(2) : (this.orderDetail.product_money + (this
								.cusTomInfo.product_price_money || 0) + this.orderDetail.logistics_money +
							this.orderDetail.total_fee_money).toFixed(2);
						this.refundOrderList = data.refund_order_list || [];
						this.returnOrderList = data.return_order_list || [];
						this.orderFlowList = data.order_flow_list || [];
						this.orderRewardList = data.order_reward_list || [];
						this.orderHistoryList = data.order_history_list || [];

					}
				});
			},
			//订单调价弹框输入等信息录入
			orderEditPriceHandle(stop) {
				if (!stop) {
					this.request({
						url: '/order/undelivered/product/list',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.editList = data;
							this.new_logistics_money = this.orderDetail.logistics_money || '0.00';
							this.$refs.orderEditPrice.open();
						}
					});

				} else {
					stop();

					var flag = false;
					var new_total_money = 0;
					this.editList.forEach(item => {
						if (!item.product_unit_price) {
							this.$message({
								text: '请输入调价后单价'
							});
							flag = true;
							return;
						} else if (parseFloat(item.product_unit_price) <= 0) {
							this.$message({
								text: '调价后的单价不能小于等于0'
							});
							flag = true;
							return;
						} else {
							new_total_money += (parseFloat(item.product_unit_price) || 0) * item.product_count;
						}
					});

					if (!this.new_logistics_money) {
						this.$message({
							text: '请输入运费'
						});
						flag = true;
						return;
					} else if (parseFloat(this.new_logistics_money) < 0) {
						this.$message({
							text: '运费不能小于0'
						});
						flag = true;
						return;
					}

					if (flag) {
						return;
					}
					new_total_money = new_total_money + (this.cusTomInfo.product_price_money || 0) + parseFloat(this
						.new_logistics_money || 0);

					if (new_total_money <= 0) {
						this.$message({
							text: '调价后的应付总额不能为0元'
						});
					}

					this.$confirm({
						text: `确定要对当前订单执行调价操作吗？<br>(原应付金额:￥${this.old_money}，调价后应付金额:<span style="color: #f00">￥${parseFloat(new_total_money).toFixed(2)}</span>)`,
						resolve: () => {
							this.orderEditPriceVerifyHandle();
							this.$refs.orderEditPrice.close();
							this.$bus.$emit('order.update', {});
						}
					});
				}
			},
			//执行订单调价请求
			orderEditPriceVerifyHandle() {
				this.request({
					url: '/order/editPrice',
					data: Object.assign({
						order_number: this.orderNumber,
						logistics_money: this.new_logistics_money,
						product_skus: Array.from(this.editList, item => {
							return {
								product_sku: item.product_sku,
								product_unit_price: parseFloat(item.product_unit_price) || 0
							}
						})
					}),
					loading: true,
					success: () => {
						this.$refs.orderEditPrice.close();
						this.$message({
							text: '调价执行成功'
						});
						this.getOrderDetail();
					}
				});
			},
			//查看物流轨迹
			showLogistics() {
				this.request({
					url: '/order/express',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.express_list = data || [];
						this.crtExpress = data[0];
						//展示物流轨迹信息
						this.$refs.logistics.open();
					}
				});
			},
			//修改买家留言响应方法
			orderRemarkHandle(stop) {
				if (!stop) {
					this.orderRemark = '';
					this.$refs.orderRemark.open();
				} else {
					stop();

					if (!this.orderRemark.trim()) {
						this.$message({
							text: '请填写备注'
						});
						return;
					}

					this.request({
						url: '/order/add_customer_service_remark',
						data: {
							order_number_arr: [this.orderNumber],
							customer_service_remark: this.orderRemark.trim()
						},
						loading: true,
						success: () => {
							this.$refs.orderRemark.close();
							this.$message({
								text: '备注成功'
							});
						}
					});
				}
			},
			//显示客服备注
			showRemarkList() {
				this.request({
					url: '/order/query_customer_service_remark_list',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.remarkList = data;
						this.$refs.remarkList.open();
					}
				});
			},
			//审核订单
			checkHandle(type, confirm) {
				var order_number_list = [];
				order_number_list.push(this.orderNumber);
				if (type == 'pass') {
					this.$confirm({
						text: '确定要审核通过该订单吗？',
						resolve: () => {
							this.request({
								url: '/order/check',
								data: {
									order_number_list: order_number_list,
									check_state: 2,
									push_u8: 2
								},
								loading: true,
								success: () => {
									this.$message({
										text: '订单审核成功'
									});
									this.getOrderDetail();
									this.$bus.$emit('order.update', {});
								}
							});
						}
					});
				} else if (confirm) {
					this.request({
						url: '/order/check',
						data: {
							order_number_list: order_number_list,
							check_state: 3,
							push_u8: 0,
							reject_reason: this.rejectReason.trim()
						},
						loading: true,
						success: () => {
							this.$message({
								text: '订单审核驳回执行成功'
							});
							this.getOrderDetail();
							this.$bus.$emit('order.update', {});
						}
					});
				} else {
					this.rejectHandle();
				}
			},
			//审核（提交数据）
			rejectHandle(stop) {
				if (!stop) {
					this.rejectReason = '';
					this.$refs.rejectReason.open();
				} else {
					stop();

					if (!this.rejectReason.trim()) {
						this.$message({
							text: '请填写审核驳回原因'
						});
						return;
					}

					this.checkHandle('reject', true);
					this.$refs.rejectReason.close();
					this.$bus.$emit('order.update', {});
				}
			},
			//关闭订单（弹窗）
			closeHandle(stop) {
				if (!stop) {
					this.cancel_reason = '';
					this.$refs.closeDia.open();
				} else {
					stop();
					if (!this.cancel_reason.trim()) {
						this.$message({
							text: '请填写关闭订单原因'
						});
						return;
					}
					this.closeSubmitForm();
					this.$refs.closeDia.close();
					this.$bus.$emit('order.update', {});

				}
			},
			//关闭订单（提交数据）
			closeSubmitForm() {
				this.request({
					url: '/order/cancel',
					data: {
						order_number: this.orderNumber,
						cancel_reason: this.cancel_reason.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							text: '申请取消订单成功'
						});
						this.getOrderDetail();
						this.$bus.$emit('order.update', {});
					}
				});
			},
			//修改买家留言
			reMarkHandle(stop) {
				if (!stop) {
					this.order_remark = this.orderDetail.order_remark;
					this.$refs.reMarkDia.open();
				} else {
					stop();
					this.request({
						url: '/order/update_remark',
						data: {
							order_number: this.orderNumber,
							order_remark: this.order_remark.trim()
						},
						loading: true,
						success: () => {
							this.$refs.reMarkDia.close();
							this.$message({
								text: '修改买家留言成功'
							});
							this.getOrderDetail();
						}
					});
				}
			},
			onInvoiceFinish() {
				this.order_ids = [this.orderDetail.id];
				this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
				this.realityMoney = parseFloat(this.orderDetail.payment_money || 0).toFixed(2);
				this.$refs.invoiceConf.open();
				this.text_msg =
					`确定要对订单【<font style="font-size:15px;color:red;">${this.orderDetail.order_number}</font>】执行开票完成操作吗？`;
			},
			submitInvoiceFinish(stop) {
				stop();
				if (!this.invoiceDate) {
					this.$message({
						text: '请选择开票时间'
					});
					return;
				}
				if (!this.realityMoney) {
					this.$message({
						text: '请输入实收金额'
					});
					return;
				}
				if (!this.invoice_file_type) {
					this.$message({
						text: '请选择开票凭证'
					});
					return;
				}
				if (!this.invoice_file) {
					if (this.invoice_file_type == 1) {
						this.$message({
							text: '请上传附件'
						});
						return;
					}
					if (this.invoice_file_type == 2) {
						this.$message({
							text: '请输入链接'
						});
						return;
					}
				} else if (this.invoice_file_type == 2) {
					if (this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0) {
						this.$message({
							text: '请输入以http://或https://开头的完整链接'
						});
						return;
					}
				}
				this.request({
					url: '/order/invoice_finish',
					data: {
						order_ids: this.order_ids,
						invoice_date: this.invoiceDate,
						reality_money: this.realityMoney,
						is_bath: 0,
						invoice_file_type: this.invoice_file_type,
						invoice_file: this.invoice_file
					},
					loading: true,
					success: data => {
						this.$message({
							icon: 'success',
							text: '执行开票完成操作成功'
						});
						this.getOrderDetail();
						this.$refs.invoiceConf.close();
					}
				});
			},
			//展示优惠明细数据
			reducedDetail(reduced_id, title) {
				this.request({
					url: '/order/reduced/detail',
					data: {
						order_number: this.orderDetail.order_number,
						reduced_id: reduced_id
					},
					loading: true,
					success: data => {
						this.reducedDetailList = data;
						this.reducedDetailTitle = (title || '') + '-优惠明细';
						this.$refs.reducedDetailDialog.open();
					}
				});
			},
			/**
			 * 安全解析 material_file 为JSON数组（模板中调用）
			 */
			parseMaterialFile(rawData) {
				if (!rawData) return [];

				// 转为字符串并去除首尾空格
				const jsonStr = String(rawData).trim();
				if (jsonStr === '') return [];

				// 尝试解析JSON，失败返回空数组
				try {
					const jsonObj = JSON.parse(jsonStr);
					// 确保返回数组（单个对象转为数组）
					return Array.isArray(jsonObj) ? jsonObj : [jsonObj];
				} catch (error) {
					console.error('JSON解析失败：', error.message);
					return []; // 解析失败时显示空列表，避免组件崩溃
				}
			},
			/**
			 * 格式化文件类型（处理null/非字符串）
			 */
			getFormatFileType(fileType) {
				if (!fileType) return "UNKNOWN";
				const typeStr = String(fileType);
				return typeStr.toUpperCase();
			},

			/**
			 * 根据文件类型获取图标类名
			 */
			getFileIconClass(fileType) {
				const type = this.getFormatFileType(fileType).toLowerCase();
				switch (type) {
					case 'jpg':
					case 'jpeg':
					case 'png':
					case 'gif':
						return 'fa-solid fa-image text-blue-500';
					case 'wps':
					case 'doc':
					case 'docx':
						return 'fa-solid fa-file-word text-green-500';
					case 'apk':
						return 'fa-solid fa-mobile-screen-button text-orange-500';
					default:
						return 'fa-solid fa-file text-gray-500';
				}
			},

			/**
			 * 格式化文件大小（处理null/无效格式）
			 */
			formatFileSize(sizeStr) {
				if (!sizeStr) return "0KB";

				const match = sizeStr.match(/^(\d+(\.\d+)?)([KMG]?B)$/i);
				if (!match) return sizeStr;

				const size = parseFloat(match[1]);
				const unit = match[3].toUpperCase();
				const units = {
					B: 1,
					KB: 1024,
					MB: 1024 * 1024,
					GB: 1024 * 1024 * 1024
				};
				const bytes = size * units[unit];

				if (bytes >= units.GB) return (bytes / units.GB).toFixed(1) + 'GB';
				if (bytes >= units.MB) return (bytes / units.MB).toFixed(1) + 'MB';
				if (bytes >= units.KB) return (bytes / units.KB).toFixed(1) + 'KB';
				return bytes + 'B';
			},

			/**
			 * 判断是否为图片文件（安全处理类型）
			 */
			isImageFile(fileType) {
				const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
				return imageTypes.includes(this.getFormatFileType(fileType).toLowerCase());
			},

			/**
			 * 下载文件（兼容file_url为null）
			 */
			downloadFile(file) {
				if (!file.file_url) {
					alert('文件下载地址无效');
					return;
				}
				const link = document.createElement('a');
				link.href = file.file_url;
				link.download = file.file_name || '未知文件';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},

			/**
			 * 预览文件（兼容file_url为null）
			 */
			previewFile(file) {
				if (!file.file_url) {
					alert('文件预览地址无效');
					return;
				}

				if (/(png|jpg|jpe?g|gif)$/i.test(file.file_url.substring(file.file_url.lastIndexOf('.') + 1))) {
					this.$preview({
						src: file.file_url
					})
				} else {
					window.open(file.file_url);
				}
			},
            showProfAgencyDialog(){
                var productTypeId = this.productList[0].product_type_id;
                this.$refs.memberProfAgencySelector.open(productTypeId)
            },
            selectProfAgencyHandle( list){
                var prof_user_id = list[0].platform_user_id;
                this.request({
                    url: '/order/invite/prof/user',
                    data: {
                        order_number: this.orderNumber,
                        prof_user_id: prof_user_id
                    },
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success' // 图标（success：成功，fail：失败）
                        });
                        this.getOrderDetail();
                        this.$refs.memberProfAgencySelector.close();
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme'

	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			font-size: 13px;
			color: #fff;
			background: #005CD9;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;

			h1 {
				font-size: 24px;
			}
		}

		&-node {
			padding: 40px 0 60px;
			margin: 14px 30px 0;
			overflow: auto;
			background: #F6FAFF;

			>>> .m-node-list {
				float: left;
				box-sizing: border-box;
				min-width: 100%;
				padding: 0 40px;

				li {
					&.z-now {
						p {
							color: #00BE50;
						}
				
						~ li {
							p {
								color: #666;
							}
						}
					}

					p {
						color: #00BE50;
					}
				}
			}
		}

		&-info {
			&:nth-child(n+2) {
				margin-left: 30px;
			}

			.tag {
				border-radius: 2px;
				padding: 0 5px;
				margin-left: 6px;
				line-height: 18px;
				color: #fff;
			}

			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}

			dd {
				padding: 12px 26px;
				background: #FAFAFA;
			}

			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;

				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}

				p {
					a {
						color: #005CD9;
					}
				}
			}
		}

		&-detail {
			padding: 30px 30px 40px;

			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-top: 25px;
				margin-bottom: 20px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
		}

		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;

			span {
				theme-color(main);
			}

			b {
				font-size: 16px;
			}
		}

		&-remark {
			padding: 20px;

			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			float: left;
			padding: 14px 18px;

			&-scroll {
				overflow: auto;
			}

			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				white-space: nowrap;
				color: #666;
				cursor: pointer;

				&:nth-child(n+2) {
					margin-left: 20px;
				}

				&:hover {
					background: #F0F3FC;
				}

				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}

		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;

			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;

				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}

	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;

		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}

		dd>div:nth-child(1) {
			margin-right 50px;
		}

		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;

			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}

			p {
				a {
					color: #005CD9;
				}
			}
		}
	}

	.invoice {
		font-size: 14px;
		color: #000;

		p {
			color: #666;
			height: 30px;
		}
	}
	
	.file-list-container {
	  padding: 20px;
	  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	}
	
	.file-list-title {
	  margin: 0 0 20px 0;
	  font-size: 18px;
	  color: #333;
	  border-bottom: 1px solid #eee;
	  padding-bottom: 10px;
	}
	
	.file-card-list {
	  display: grid;
	  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	  gap: 5px;
	}
	
	.file-card {
	  display: flex;
	  align-items: center;
	  padding: 5px 12px;
	  border: 1px solid #eee;
	  border-radius: 8px;
	  transition: all 0.3s ease;
	  background-color: #fff;
	}
	
	.file-card:hover {
	  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	  border-color: #e0e0e0;
	}
	
	.file-icon {
	  margin-right: 12px;
	  font-size: 24px;
	}
	
	.file-info {
	  flex: 1;
	  min-width: 0;
	}
	
	.file-name {
	  font-size: 14px;
	  color: #333;
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  margin-bottom: 4px;
	}
	
	.file-meta {
	  display: flex;
	  align-items: center;
	  font-size: 12px;
	  color: #666;
	  gap: 8px;
	}
	
	.file-type-tag {
	  padding: 2px 6px;
	  border-radius: 4px;
	  background-color: #f5f5f5;
	  color: #888;
	}
	
	.file-actions {
	  display: flex;
	  gap: 8px;
	}
	
	.btn-download, .btn-preview {
	  padding: 4px 8px;
	  border: none;
	  border-radius: 4px;
	  font-size: 12px;
	  cursor: pointer;
	  display: flex;
	  align-items: center;
	  gap: 4px;
	}
	
	.btn-download {
	  background-color: #4299e1;
	  color: white;
	}
	
	.btn-download:hover {
	  background-color: #3182ce;
	}
	
	.btn-preview {
	  background-color: #f5f5f5;
	  color: #333;
	}
	
	.btn-preview:disabled {
	  background-color: #fafafa;
	  color: #ccc;
	  cursor: not-allowed;
	}
	
	.btn-preview:not(:disabled):hover {
	  background-color: #eee;
	}
	
	@import url('https://cdn.bootcdn.net/ajax/libs/font-awesome/6.4.0/css/all.min.css');
	
	.no-file-tip {
	  padding: 20px;
	  color: #666;
	  text-align: center;
	  background-color: #f9f9f9;
	  border-radius: 8px;
	  margin: 10px 0;
	}

	.service-record {
		max-height: 400px;
		overflow: auto;
		background: #FAFAFA;

		ul {
			position: relative;
			padding: 20px 50px;

			&:before {
				content: '';
				position: absolute;
				left: 32px;
				top: 20px;
				bottom: 0;
				width: 1px;
				background: #eee;
			}

			li {
				position: relative;

				&:nth-child(n+2) {
					margin-top: 12px;
				}

				&:before {
					content: '';
					position: absolute;
					left: -23px;
					top: 3px;
					box-sizing: border-box;
					width: 12px;
					height: 12px;
					border: 2px solid #ddd;
					border-radius: 100%;
					background: #fff;

					^[-1]:nth-child(1)^[-1..-1] {
						border-color: #0060EF;
					}
				}

				&:nth-child(1) {
					.service {
						&-date {
							font-size: 13px;
							font-weight: bold;
							color: #0060EF;
						}
					}
				}

				.service {
					&-date {
						line-height: 20px;
						font-size: 12px;
						color: #999;
					}

					&-remark {
						margin-top: 6px;
						line-height: 22px;
						font-size: 13px;
					}

					&-file {
						padding: 0 14px;
						margin-top: 6px;
						background: #F5F5F5;

						&-item {
							gap: 10px;
							height: 46px;
							font-size: 12px;
							color: #666;
							cursor: pointer;

							&:hover {
								color: #0060EF
							}

							i {
								font-size: 24px;
							}

							p {
								max-width: 300px;
							}
						}
					}
				}
			}
		}
	}
</style>